import axios from 'axios'
import getDateFormatUser from "../../components/getDateFormatUser/getDateFormatUser";

export const GET_SETTINGS_DATE_ORDER = 'GET_SETTINGS_DATE_ORDER';
export const SET_UPDATE_DATE_ORDER_PULL = 'SET_UPDATE_DATE_ORDER_PULL';

export const getSettingsDateOrderPull = (data) => (dispatch) => {
        dispatch({
            type: GET_SETTINGS_DATE_ORDER,
            payload:data,
        })
}


export const setUpdateDateOrderPull = (d, userPeriodStart = new Date(),userPeriodStop = new Date()) => (dispatch) => {
    // console.log('Пришли данные для замены стейта кнопки периода выгрузки заказов ', d);


    const dateInput = new Date();

    let nowDayWeek = dateInput.getDay();

    if(nowDayWeek == 0){
        nowDayWeek = 7;
    }

    // console.log("текущее число ",dateInput);

    let backWeekDay = nowDayWeek-1;
    if(backWeekDay <0){backWeekDay = 0}

    const nowDate = getDateFormatUser(dateInput,"next",0);
    const backDate = getDateFormatUser(dateInput,"back",1);
    const nextDate = getDateFormatUser(dateInput,"next",1);
    const weekback = getDateFormatUser(dateInput,"back",backWeekDay);
    const weeknext = getDateFormatUser(dateInput,"next",(7-nowDayWeek));

    const SpecifyStart = getDateFormatUser(userPeriodStart,"next",0);
    const SpecifyStop = getDateFormatUser(userPeriodStop,"next",0);


    let date = dateInput, y = date.getFullYear(), m = date.getMonth();
    let firstDay = getDateFormatUser(new Date(y, m, 1),"next",0);
    let lastDay = getDateFormatUser(new Date(y, m + 1, 0),"next",0);


    let dateStart = nowDate;
    let dateStop = nowDate;

    switch (d) {
        case "Tomorrow":
            dateStart = nextDate;
            dateStop = nextDate;
            break;
        case "ToDay":
            dateStart = nowDate;
            dateStop = nowDate;
            break;
        case "Yesterday":
            dateStart = backDate;
            dateStop = backDate;
            break;
        case "Week":
            dateStart = weekback;
            dateStop = weeknext;
            break;
        case "Month":
            dateStart = firstDay;
            dateStop = lastDay;
            break;
        case "Specify":
            dateStart = SpecifyStart;
            dateStop = SpecifyStop;
            break;
        default:
    }

    let resultDispatch = {typeOrderDate:d,dateStartSpecify: dateStart,
        dateStopSpecify: dateStop};

        dispatch({
            type: SET_UPDATE_DATE_ORDER_PULL,
            payload:resultDispatch,
        })

    return resultDispatch;

}

//
// export const getCategoryList = () => (dispatch) => {
//     axios.get('/api/ecommerce/get-category-list').then((res) => {
//         dispatch({
//             type: GET_CATEGORY_LIST,
//             payload: res.data,
//         })
//     })
// }

